export default __webpack_public_path__ + "static/media/mv-dtc-iphone-3.de2c8f4f.png";